import gql from 'graphql-tag';

export const getContactHistories = gql`
  query getContactHistories($id: String) {
    getContactHistories(id: $id) {
      updater
      updatedAt
    }
  }
`;
